import './listing-features.css';
import { IListing } from '../../../models/listing.model';
import { useCallback, useMemo } from 'react';
import { formatNumber } from '../../../util/format-number';

export interface ListingFeaturesProps {
  listing: IListing;
}

interface ListingFeature {
  keyname: keyof IListing;
  description: string;
  type: 'string' | 'currency' | 'number';
}

const attrs: ListingFeature[] = [
  { keyname: 'maintenanceFees', description: 'Maintenance Fees', type: 'currency' },
  { keyname: 'annualPropertyTax', description: 'Annual Property Tax', type: 'currency' },
  { keyname: 'buildingName', description: 'Building Name', type: 'string' },
  { keyname: 'age', description: 'Age', type: 'string' },
  { keyname: 'buildYear', description: 'Build Year', type: 'string' },
  { keyname: 'swimmingPool', description: 'Swimming Pool', type: 'string' },
  { keyname: 'jacuzzi', description: 'Jacuzzi', type: 'string' },
  { keyname: 'heatingSystem', description: 'Heating System', type: 'string' },
  { keyname: 'coolingSystem', description: 'Cooling System', type: 'string' },
  { keyname: 'elevator', description: 'Elevator', type: 'string' },
  { keyname: 'balcony', description: 'Balcony', type: 'string' },
  { keyname: 'basement', description: 'Basement', type: 'string' },
  { keyname: 'fence', description: 'Fence', type: 'string' },
  { keyname: 'view', description: 'View', type: 'string' },
  { keyname: 'petPolicy', description: 'Pet Policy', type: 'string' },
  { keyname: 'kitchen', description: 'Kitchen', type: 'string' },
  { keyname: 'fireplace', description: 'Fireplace', type: 'string' },
  { keyname: 'security', description: 'Security', type: 'string' },
  { keyname: 'patio', description: 'Patio', type: 'string' },
  { keyname: 'roofDeck', description: 'Roof Deck', type: 'string' },
  { keyname: 'storage', description: 'Storage', type: 'string' },
  { keyname: 'furnished', description: 'Furnished', type: 'string' },
  { keyname: 'ensuiteLaundry', description: 'Ensuite Laundry', type: 'string' },
  { keyname: 'windowView', description: 'Window View', type: 'string' },
  { keyname: 'livingAreaSqFootage', description: 'Living Area Sq Footage', type: 'string' },
  { keyname: 'lotAreaSquareFootage', description: 'Lot Area Square Footage', type: 'string' },
];

export const ListingFeatures = (props: ListingFeaturesProps) => {

  const hasValue = useCallback(function (keyname: keyof IListing) {
    if (props.listing[keyname] === undefined ||
      props.listing[keyname] === null ||
      props.listing[keyname] === '' ||
      props.listing[keyname] === '0') {
      return false;
    }
    return true;
  }, [props.listing]);

  const attributes = useMemo(() =>
    attrs.map((attr, i) =>
      hasValue(attr.keyname) &&
      <div className="attribute-container" key={i}>
        <div>
          <span className="attribute-description">
            {attr.description}{': '}
          </span>
          <span className="attribute-value">
            {attr.type === 'currency' && '$'}
            {attr.type === 'currency'
              ? formatNumber(Number(props.listing[attr.keyname]))
              : props.listing[attr.keyname]
            }
          </span>
        </div>
      </div>
    ), [hasValue, props.listing]);

  return (
    <div id='features' className="listing-features-container">
      <h2 className="title">Property Features</h2>
      <div className="listing-features">
        {attributes}
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
